interface BetterAuthSessionClient {
	signOut: () => Promise<{ error?: unknown }>;
}

type LoadBetterAuthSessionClient = () => Promise<BetterAuthSessionClient>;

const loadBetterAuthSessionClient: LoadBetterAuthSessionClient = async () => {
	const { authClient } = await import("./auth-client");
	return authClient;
};

/**
 * End the current browser session through Better Auth's client API.
 *
 * The client is loaded only when rollback actually needs to sign out. Keeping
 * the import lazy prevents auth-flows unit tests and non-auth consumers from
 * eagerly evaluating Sigma's full Better Auth client-plugin graph.
 */
export async function signOutBetterAuthSession(
	loadClient: LoadBetterAuthSessionClient = loadBetterAuthSessionClient
): Promise<void> {
	const client = await loadClient();
	const { error } = await client.signOut();
	if (error) {
		throw new Error("Failed to tear down orphaned sign-in session");
	}
}
